/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Stack, Text } from "@microsoft/shifts-ui-core";
import * as React from "react";

import { getCellsProps, getTranslations } from "./ScheduleGroupPeopleCountRow.mappers";
import { getClassNames } from "./ScheduleGroupPeopleCountRow.styles";
import { ScheduleGroupPeopleCountRowProps } from "./ScheduleGroupPeopleCountRowProps";

/**
 * Renders the row showing "Staff per 6 hours" for one schedule group.
 * This is used in "Week" view only.
 * @param props The properties.
 * @returns The rendered "Staff per 6 hours" row.
 */
export const ScheduleGroupPeopleCountRow: React.FC<ScheduleGroupPeopleCountRowProps> = props => {
    const cellsProps = getCellsProps(props);
    const classNames = getClassNames();
    const translations = getTranslations();
    const cellClassNames = `${classNames.cell} ${classNames.contentCell}`;

    return (
        <Stack horizontal>
            <Stack.Item align="center" className={`${classNames.cell} ${classNames.titleCell}`}>
                <Text className={classNames.title} variant="small">
                    {translations.get("staffPerHoursTitle").replace("{count}", "6")}
                </Text>
            </Stack.Item>
            {cellsProps.map(({ children, className, key }) => (
                <Stack.Item align="center" className={className ? `${cellClassNames} ${className}` : cellClassNames} grow key={key}>
                    <Text className={classNames.text} variant="small">
                        {children}
                    </Text>
                </Stack.Item>
            ))}
        </Stack>
    );
};
